import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FooterMenu from './footer-menu';
import LogoSquare from '../logo-square';
import { getMenu } from 'lib/burokshop';
import type { Menu } from 'lib/burokshop/types';

const SITE_NAME = import.meta.env.VITE_SITE_NAME || 'ShopLink';

export default function Footer() {
  const [menu, setMenu] = useState<Menu[]>([]);
  const currentYear = new Date().getFullYear();
  const copyrightDate = 2025 + (currentYear > 2023 ? `-${currentYear}` : '');
  const copyrightName = 'BUROK';

  useEffect(() => {
    async function loadMenu() {
      try {
        const menuData = await getMenu('next-js-frontend-footer-menu');
        setMenu(menuData);
      } catch (error) {
        console.error('Error loading footer menu:', error);
        setMenu([]);
      }
    }
    loadMenu();
  }, []);

  return (
    <footer className="text-sm text-neutral-500 dark:text-neutral-400">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-6 border-t border-neutral-200 px-6 py-12 text-sm md:flex-row md:gap-12 md:px-4 min-[1320px]:px-0 dark:border-neutral-700">
        <div>
          <Link className="flex items-center gap-2 text-black md:pt-1 dark:text-white" to="/">
            <LogoSquare size="sm" />
            <span className="uppercase">{SITE_NAME} - Burok</span>
          </Link>
        </div>
        <FooterMenu menu={menu} />
        <div className="md:ml-auto flex items-center">
          <img
            src="/assets/images/DownloadBurok.png"
            alt="Télécharger l'application Burok"
            className="h-auto max-h-20 w-auto object-contain"
          />
        </div>
      </div>
      <div className="border-t border-neutral-200 py-6 text-sm dark:border-neutral-700">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-1 px-4 md:flex-row md:gap-0 md:px-4 min-[1320px]:px-0">
          <p>
            &copy; {copyrightDate} {copyrightName}
            {copyrightName.length && !copyrightName.endsWith('.') ? '.' : ''} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}



